import moment from "moment";

const state = {
    products:[],
    product:null,
};

const getters = {
    products: state => state.products,
    product: state => state.product,

    inactiveDates: state => {

        if(!state.product.inactive_dates){
            let now = moment();
            const endDate = moment().add(2, 'y');
            let dates = [];

            while(now.isSameOrBefore(endDate)){
                if (now.isoWeekday() === 1){
                    dates.push(now.format('YYYY-MM-DD'));
                }
                now.add(1,'days');
            }
            return dates;
        }

        let daysFromBackend = state.product.inactive_dates.map(item => {
            return moment(item.inactive_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        });

        const today = moment();
        const endDate = moment().add(2, 'y');

        let now = today.clone();
        let dates = [];

        while(now.isSameOrBefore(endDate)){
            if (now.isoWeekday() === 1){
                dates.push(now.format('YYYY-MM-DD'));
            }
            now.add(1,'days');
        }

        return dates.concat(daysFromBackend);
    },
};

const actions = {
    getProducts({commit, state}){
        axios.get('/api/admin/product').then((response) => {
            commit('setProducts', response.data.data);
        })
    },
    getProduct({commit, state}, product_id){
        axios.get(`/api/admin/product/${product_id}`).then((response) => {
            response.data.data.image_name = '';
            commit('setProduct', response.data.data);
        })
    },
    clearProduct({commit}){
        commit('clearProduct');
    }
};

const mutations = {
    setProducts(state, products){
        state.products = products;
    },
    setProduct(state, product){
        state.product = product;
    },
    clearProduct(state){
        state.product = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
